import { ChevronUp } from 'feather-icons-react'
import React from 'react'
import BackButton from './UI/BackButton'

const HeaderWithBackTopArrow = () => {
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    }

    return (
        <header className='bg-transparent py-3 fixed top-0 w-full z-10 pointer-events-none'>
            <div className='container'>
                <div className='flex justify-between black-drop-shadow'>
                    <BackButton className='pointer-events-auto' />
                    <ChevronUp size="35" color="#00e6f4" onClick={scrollToTop} className='pointer-events-auto sm:hidden' />
                </div>
            </div>
        </header>
    )
}

export default HeaderWithBackTopArrow